import { useTranslation } from "react-i18next";
import { Menu } from "../../icons";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { SolutionBannerAPI } from "@api";
import "./SolutionBadge.scss";

const Content = styled.div`
  padding: 0 16px;

  img {
    height: 116px;
    object-fit: cover;
    border-radius: 0px 16px;
    over-flow: hidden;
  }

  @media (max-width: 576px) {
    img {
      height: 88px;
    }
  }
`;

const SolutionBadge = () => {
  const [index, setIndex] = useState(0);
  const [banner, setBanner] = useState([]);
  const { t } = useTranslation();

  const next = () => {
    setIndex((index + 1) % banner.length);
  };

  const previous = () => {
    if (index === 0) {
      setIndex(banner.length - 1);
      return;
    }
    setIndex((index - 1) % banner.length);
  };

  useEffect(() => {
    async function loadData() {
      if (banner.length < 1) {
        const bannerData = (await SolutionBannerAPI({type: "others"})).data;        
        setBanner(bannerData.data);
      }
    }

    loadData();
  }, [banner]);

  return (
    <div className="solution-badge">
      <div className="header">
        <div className="col-8 d-flex justify-content-start align-items-center">
          <Menu fill="#85714d" className="icon" />
          <div className="title color-brown">{t("other_solution")}</div>
        </div>
        <div className="navigation">
          {banner.length > 1 ? (
            <div className="col d-flex justify-content-end">
              <div className="d-flex">
                <button className="btn d-flex justify-content-center align-items-center btn-outline-primary" onClick={previous}>
                  <i className="bi bi-chevron-left"></i>
                </button>
                <button className="btn d-flex justify-content-center align-items-center btn-outline-primary" onClick={next}>
                  <i className="bi bi-chevron-right"></i>
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Content className="position-relative">
        {banner.map((data, i) => {
          return i === index ? (
            <img src={data.image} width="100%" key={i} alt={data.title} />
          ) : (
            ""
          );
        })}
      </Content>
    </div>
  );
};

export default SolutionBadge;
